<template>
  <div>
    <div
      style="
        max-height: 100vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      "
    >
      <v-autocomplete
        :items="optionsSort"
        :name="name"
        :placeholder="placeholderValidate"
        v-model="itemsValue"
        :model-value="itemsValue || null"
        @update:modelValue="val => updateModelValue(val)"
        :item-value="valueField"
        :item-title="textField"
        :ref="'autocomplete-' + name"
        :disabled="disabled"
        :label="isRequired ? title + ' *' : title"
        :single-line="singleLine"
        hide-details
        :type="type"
        color="#dbdbdb"
        :error="isValidate"
        :auto-select-first="autoSelectFirst"
        autocomplete="off"
        :loading="isLoading"
        clear-on-select
        :style="{
          color: isValidate ? 'red' : ''
        }"
        :persistent-placeholder="isValidate || persistentPlaceholder"
        :menu-props="{ top: true, maxHeight: '150px', offsetY: true }"
        @focus="scrollToInput"
      >
        <!-- :search="itemsValue" -->
        <template v-slot:prepend-item>
          <v-list-item :value="null" disabled selected v-if="value == null">
            <span v-if="options.length > 0">
              --
              <slot name="options-name">{{
                placeholder || $t("default_select_validate")
              }}</slot>
              --</span
            >
            <span v-else>-- {{ $t("no_date") }} --</span>
          </v-list-item>
          <v-list-item
            :value="'N/A'"
            disabled
            selected
            v-else-if="value == 'N/A'"
          >
            <span v-if="options.length > 0">
              --
              <slot name="options-name">{{
                placeholder || $t("default_select_validate")
              }}</slot>
              --</span
            >
            <span v-else>-- {{ $t("no_date") }} --</span>
          </v-list-item>
          <v-list-item value="" disabled selected v-else>
            <span v-if="options.length > 0">
              <slot name="options-name">
                -- {{ placeholder || $t("default_select_validate") }} --</slot
              >
            </span>
            <span v-else>-- {{ $t("no_date") }} --</span>
          </v-list-item>
        </template>
        <template v-slot:item="{ item, props }">
          <v-list-item v-bind="props">
            <template v-slot:prepend>
              <img
                :src="item.raw.flag"
                alt="flag"
                v-if="item.raw.flag"
                style="width: 20px; height: 14px; margin-right: 8px"
              />
            </template>
            <v-list-item-title>
              {{ item[textField] }}
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-slot:selection="{ item }">
          <div class="d-flex align-center">
            <span v-if="item">
              <img
                v-if="getFlag()"
                :src="getFlag()"
                alt="flag"
                style="width: 20px; height: 14px; margin-right: 8px"
              />
              {{
                typeof item.raw === "string"
                  ? getCode(item.raw)
                  : item.raw?.[textField] || item.title || item.value
              }}
            </span>
            <span v-else class="text-muted">
              <img
                v-if="getFlag()"
                :src="getFlag()"
                alt="flag"
                style="width: 20px; height: 14px; margin-right: 8px"
              />
              {{ placeholder || $t("default_select_validate") }}
            </span>
          </div>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: false
    },
    singleLine: {
      required: false
    },
    label: {
      required: false
    },
    text: {
      required: false
    },
    name: {
      required: false
    },
    size: {
      required: false
    },
    options: {
      required: true,

      default: () => []
    },
    value: {
      required: false
    },
    isRequired: {
      required: false,
      type: Boolean
    },
    isValidate: {
      required: false
    },
    v: {
      required: false
    },
    valueField: {
      required: false
    },
    textField: {
      required: false
    },
    disabled: {
      required: false
    },
    placeholder: {
      required: false
    },
    validateText: {
      required: false
    },
    eachValid: {
      required: false,
      type: Object,
      default: null
    },
    formType: {
      required: false,
      default: false,
      type: Boolean
    },
    type: {
      required: false,
      default: "text",
      type: String
    },
    autoSelectFirst: {
      required: false,
      type: Boolean,
      default: false
    },
    customPlaceholder: {
      required: false,
      type: Boolean,
      default: false
    },
    persistentPlaceholder: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      selected: 0,
      dataValue: null,
      isLoading: false,
      search: ""
    };
  },

  created() {
    this.setOtherValue();
  },
  mounted() {
    this.setDefault();
    // if (this.options.length == 0)
    //   this.$logger({
    //     response: { config: { url: `` } },
    //     action: {
    //       action: "field select options empty",
    //       id: 3,
    //       note: `Field Name : ${this.title}`
    //     }
    //   });
  },
  watch: {
    options: {
      handler: function (val, oldVal) {
        if (this.formType) {
          // if (val.length == 0) this.$logger({ response: { config: {} } });
          if (
            val.length != oldVal.length &&
            val.find(el => el.name == this.value)
          )
            return;
          if (
            val.length == oldVal.length &&
            val.find(el => el.name == this.value)
          )
            return;
          if (
            (val.length != oldVal.length || val.length == oldVal.length) &&
            !val.find(el => el.name == this.value)
          )
            return this.setOtherValue(val);
        }
      },
      deep: true
    }
  },
  computed: {
    itemsValue() {
      return this.value;
    },
    searchValue() {
      let value = this.options.find(el => el[this.valueField] == this.value);
      return value ? value[this.textField] : "";
    },
    optionsSort() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
      // this.value = "";
      // this.$refs.input.focus();
      return this.options.sort((a, b) => a.sort_order - b.sort_order);
    },
    placeholderValidate() {
      if (this.isValidate) {
        if (this.isValidate) {
          // if (this.isNotValidate) return this.textFloat;
          return this.placeholder + " " + this.$t("default_select_validate");
        } else if (this.isRequired) return this.placeholder;
      } else return this.placeholder;
    }
  },
  methods: {
    setOtherValue(val) {
      if (this.formType)
        if (this.value && this.options.length > 0) {
          let value = this.options.find(el => el.name == this.value);
          if (!value) {
            let other = this.options.find(el => el.choice_type_id == 3);

            if (other) {
              this.$emit("setOtherValue", this.value);
              this.$emit("update:value", other ? other.name : "");
            }
          }
        }
    },
    setDefault() {
      if (this.formType) {
        if (this.value) return;
        this.$nextTick(() => {
          let check = this.options.find(el => el.isDefault == 1);

          if (check) {
            this.$emit("update:value", check.name);
          }
        });
      }
    },

    updateModelValue(val) {
      let find = this.options.find(el => el.name == val);

      if (find) if (find.choice_type_id == 3) this.$emit("deleteOtherValue");

      this.$emit("change", val);
      this.$emit("update:value", val);
    },
    focus() {
      this.$refs.input.focus();
    },
    clearField(val) {
      if (!val) {
      }
    },
    getFlag(value) {
      let flag = this.options.find(el => el[this.valueField] == this.value);
      return flag?.flag;
    },
    getCode(value) {
      if (!value) return "";
      let country = this.options.find(el => el[this.valueField] == value);
      // console.log(country, value, country?.dial_code || value);
      return country ? country?.dial_code : value;
    },
    scrollToInput() {
      setTimeout(() => {
        const el = this.$refs["autocomplete-" + this.name]?.$el;
        el?.scrollIntoView({ behavior: "smooth", block: "center" });
        // const y = el?.getBoundingClientRect().top + window.scrollY + 50;
        // el?.scrollTo({ behavior: "smooth", top: y });
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.select-custom {
  // margin-bottom: 15px;
  position: relative;
  white-space: nowrap;

  // padding-bottom: 15px;
}
.select-custom.error {
  border-color: red !important;
}
.select-custom.error > .btn-select {
  border-color: red !important;
}
.select-custom > label {
  // color: gray;
  font-size: var(--text-2xl);
  margin-bottom: 5px;
  width: 100%;
}
::v-deep .btn-select {
  color: #575757;
  background-color: white;
  border: 1px solid #dbdbdb;
  border-radius: 0.25rem;
  padding: 5px 10px;
  cursor: pointer;
  height: 45px;
}
::v-deep .btn-select.custom-select-lg {
  height: 45px;
  font-size: 1rem;
}

::v-deep .btn-select:focus {
  border-color: gray;
}
::v-deep .btn-select > option {
  background-color: white;
  color: gray;
}
::v-deep .btn-select > option:checked {
  background-color: gray !important;
  color: white !important;
}
::v-deep .btn-select:focus {
  box-shadow: unset !important;
}
</style>
